import { jsx } from 'react/jsx-runtime';
import { SvgIcon } from '../../SvgIcon/SvgIcon/index.js';

const IconMinusLarge = SvgIcon({
    // eslint-disable-next-line max-len
    children: jsx("path", { d: "M3 12c0-.203.07-.375.21-.516a.74.74 0 0 1 .54-.234h16.5c.203 0 .375.078.516.234.156.141.234.313.234.516a.741.741 0 0 1-.234.54.701.701 0 0 1-.516.21H3.75a.782.782 0 0 1-.54-.21A.782.782 0 0 1 3 12z" }),
});

export { IconMinusLarge };
